// Carrossel de tutorial
const gliderEl = document.querySelector('.tutorial-anuencia-glider');

if (gliderEl) {
   const glider = new Glider(gliderEl, {
      slidesToShow: 1,
      slidesToScroll: 1,
      scrollLock: true,
      draggable: true,
      duration: 0.5,
      arrows: {
         prev: '.tutorial-anuencia-prev',
         next: '.tutorial-anuencia-next',
      },
      dots: '.tutorial-anuencia-dots',
   });

   // Elementos de informação do passo
   const stepInfoBlocks = document.querySelectorAll('.tutorial-anuencia-lp__step-info');

   // Função para atualizar qual bloco está visível
   function updateStepInfo(slideIndex) {
      stepInfoBlocks.forEach((block, index) => {
         if (index === slideIndex) {
            block.classList.add('active');
         } else {
            block.classList.remove('active');
         }
      });
   }

   // Atualizar ao mudar de slide
   gliderEl.addEventListener('glider-slide-visible', function (event) {
      updateStepInfo(event.detail.slide);
   });

   // Posicionar botões na metade do glider-track
   function positionArrows() {
      const gliderTrack = document.querySelector('.glider-track');
      const prevBtn = document.querySelector('.tutorial-anuencia-prev');
      const nextBtn = document.querySelector('.tutorial-anuencia-next');

      if (gliderTrack && prevBtn && nextBtn) {
         const trackHeight = gliderTrack.offsetHeight;
         const topPosition = trackHeight / 2;

         prevBtn.style.top = `${topPosition}px`;
         nextBtn.style.top = `${topPosition}px`;
      }
   }

   // Posicionar após o carregamento
   setTimeout(positionArrows, 100);

   // Reposicionar ao redimensionar a janela
   window.addEventListener('resize', positionArrows);
}

// Carrossel de cards "Por que confirmar" (apenas mobile)
const reasonsCardsEl = document.querySelector('.reasons-anuencia-lp__cards');
let reasonsGlider = null;

function initReasonsCarousel() {
   if (reasonsCardsEl && window.innerWidth <= 700) {
      // Inicializar apenas se ainda não foi inicializado
      if (!reasonsGlider) {
         reasonsGlider = new Glider(reasonsCardsEl, {
            slidesToShow: 1.2,
            slidesToScroll: 1,
            draggable: true,
            scrollLock: false,
            duration: 0.3,
         });
      }
   } else if (reasonsGlider) {
      // Destruir glider no desktop
      reasonsGlider.destroy();
      reasonsGlider = null;
   }
}

// Inicializar na carga
initReasonsCarousel();

// Reinicializar ao redimensionar
window.addEventListener('resize', initReasonsCarousel);
